import { render } from "./vehicle-costs.vue?vue&type=template&id=73e6de4c"
import script from "./vehicle-costs.vue?vue&type=script&lang=js"
export * from "./vehicle-costs.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__